import { Typography } from '@design-system/components/typography/typography';

type AuthTermsNoticeProps = {
  textClassName: string;
  linkClassName: string;
};

type AuthClientAppHintProps = {
  hintClassName: string;
  linkClassName: string;
};

const CLIENT_APP_DOWNLOAD_URL = 'https://playbookapp.io/download';
const PRIVACY_POLICY_URL = 'https://www.playbookapp.io/privacy-policy';
const TERMS_OF_SERVICE_URL = 'https://www.playbookapp.io/terms-of-service';
const CREATOR_AGREEMENT_URL = 'https://www.playbookapp.io/creator-agreement';

export const AuthTermsNotice = (p: AuthTermsNoticeProps) => (
  <Typography variant="body" size="small" className={p.textClassName}>
    By signing up, you agree to our{' '}
    <a
      className={p.linkClassName}
      href={PRIVACY_POLICY_URL}
      target="_blank"
      rel="noreferrer"
    >
      Privacy Policy
    </a>
    ,{' '}
    <a
      className={p.linkClassName}
      href={TERMS_OF_SERVICE_URL}
      target="_blank"
      rel="noreferrer"
    >
      Terms of Service
    </a>
    , and{' '}
    <a
      className={p.linkClassName}
      href={CREATOR_AGREEMENT_URL}
      target="_blank"
      rel="noreferrer"
    >
      Creator Agreement
    </a>
    .
  </Typography>
);

export const AuthClientAppHint = (p: AuthClientAppHintProps) => (
  <Typography variant="body" size="medium" className={p.hintClassName}>
    Looking for the app to train with?{' '}
    <a
      className={p.linkClassName}
      href={CLIENT_APP_DOWNLOAD_URL}
      target="_blank"
      rel="noreferrer"
    >
      Download the client app
    </a>
  </Typography>
);
